import { render, staticRenderFns } from "./ReportSingleAgent.vue?vue&type=template&id=6dc67c12&scoped=true&"
import script from "./ReportSingleAgent.vue?vue&type=script&lang=js&"
export * from "./ReportSingleAgent.vue?vue&type=script&lang=js&"
import style0 from "./ReportSingleAgent.vue?vue&type=style&index=0&id=6dc67c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc67c12",
  null
  
)

export default component.exports